import { slicedToArray as _slicedToArray, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect, Children } from 'react';
import { useContextSelector } from 'use-context-selector';
import Portal from '../../../components/Portal/Portal.js';
import { jsx } from '@emotion/react';
import '../../../contexts/internal/StickyContext.js';
import { EditorContext } from '../../../contexts/internal/EditorContext.js';
import 'lodash-es';
import '@bucketplace/ui';
import { useEditorNode } from '../../../hooks/useEditorNode.js';
import 'qs';
import 'query-string';
import '@bucketplace/bucket-log';
import { useTabContext } from '../Tab.js';

function TabItem(_ref) {
  var children = _ref.children,
    index = _ref.index,
    path = _ref.path,
    logData = _ref.logData;
  var _useTabContext = useTabContext(),
    id = _useTabContext.id,
    currentIndex = _useTabContext.currentIndex;
  var _useEditorInitializer = useEditorInitializer({
      index: index,
      path: path
    }),
    visibleButton = _useEditorInitializer.visibleButton;
  function renderTabButtons() {
    var _filterChildren = filterChildren(children, 'tabButton'),
      _filterChildren2 = _slicedToArray(_filterChildren, 2),
      tabOnButton = _filterChildren2[0],
      tabOffButton = _filterChildren2[1];
    if (!tabOnButton || !tabOffButton) {
      return;
    }
    var isCurrentTab = index === currentIndex;
    if (visibleButton) {
      return jsx(React__default.Fragment, null, visibleButton === 'on' && /*#__PURE__*/React__default.cloneElement(tabOnButton, {
        index: index,
        logData: logData
      }), visibleButton === 'off' && /*#__PURE__*/React__default.cloneElement(tabOffButton, {
        index: index,
        logData: logData
      }));
    }
    return jsx(React__default.Fragment, null, isCurrentTab && /*#__PURE__*/React__default.cloneElement(tabOnButton, {
      index: index,
      logData: logData
    }), !isCurrentTab && /*#__PURE__*/React__default.cloneElement(tabOffButton, {
      index: index,
      logData: logData
    }));
  }
  function renderTabContent() {
    var _filterChildren3 = filterChildren(children, 'tabContent'),
      _filterChildren4 = _slicedToArray(_filterChildren3, 1),
      tabContent = _filterChildren4[0];
    if (!tabContent) {
      return null;
    }
    return jsx(Portal, {
      containerSelector: "#tab-".concat(id, "-panel")
    }, /*#__PURE__*/React__default.cloneElement(tabContent, {
      index: index
    }));
  }
  return jsx(React__default.Fragment, null, renderTabButtons(), renderTabContent());
}
function useEditorInitializer(_ref2) {
  var index = _ref2.index,
    path = _ref2.path;
  var context = useContextSelector(EditorContext, function (context) {
    return context;
  });
  var isInEditor = !!context;
  var _useTabContext2 = useTabContext(),
    selectIndex = _useTabContext2.selectIndex;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    visibleButton = _useState2[0],
    setVisibleButton = _useState2[1];
  var tabOnButtonNode = useEditorNode([].concat(_toConsumableArray(path), [0]));
  var tabOffButtonNode = useEditorNode([].concat(_toConsumableArray(path), [1]));
  function configureVisibleButton() {
    if (!isInEditor) {
      return;
    }
    if (tabOnButtonNode.isChildSelected) {
      setVisibleButton('on');
      selectIndex(index);
    } else if (tabOffButtonNode.isChildSelected) {
      setVisibleButton('off');
    } else {
      setVisibleButton(undefined);
    }
  }
  useEffect(configureVisibleButton, [tabOnButtonNode.isChildSelected, tabOffButtonNode.isChildSelected]);
  return {
    visibleButton: visibleButton
  };
}
function filterChildren(children, id) {
  return Children.toArray(children).reduce(function (acc, child) {
    if (! /*#__PURE__*/React__default.isValidElement(child)) {
      return acc;
    }
    var childId = child.type.id;
    return childId === id ? [].concat(_toConsumableArray(acc), [child]) : acc;
  }, []);
}

export { TabItem };
//# sourceMappingURL=TabItem.js.map
